/* Luzzart · Gaveta do carrinho (handoff "Side Cart", 08/10/2026). Sem dependências.
   O tema (cart.js) abre e fecha a gaveta e a refaz depois de cada compra (renderContents); este arquivo cuida do resto:
   quantidade, remover e desfazer, atalho de faixa de desconto, foco e rolagem. */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var busy = false;
  var undo = null, undoTimer = 0;
  var tiersMem = {};                             // handle -> [{min, pct, unit}]

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function brl(cents) { return (Math.round(cents) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace(/ /g, ' '); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { /* sem armazenamento */ } return null; }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function drawer() { return document.querySelector('cart-drawer.lzd'); }
  function host() { return document.getElementById('CartDrawer'); }
  function body() { return q('[data-lzd-body]'); }
  function items() { return qa('[data-lzd-item]'); }
  function isOpen() { var d = drawer(); return !!(d && d.classList.contains('active')); }

  function live(msg) {
    var el = q('[data-lzd-live]'); if (!el) return;
    el.textContent = '';
    window.setTimeout(function () { el.textContent = msg; }, 30);
  }
  function showError(msg) {
    var el = q('[data-lzd-err]'); if (!el) return;
    el.textContent = msg || ''; el.hidden = !msg;
    if (msg) { var b = body(); if (b) b.scrollTop = 0; try { el.focus({ preventScroll: true }); } catch (e) { /* sem foco */ } }
  }
  function erroTexto(err) {
    var d = err && err.data && err.data.description ? String(err.data.description) : '';
    if (err && err.status === 429) return 'Muitas tentativas seguidas. Espere alguns segundos e tente de novo.';
    if (err && err.status === 422 && /par[aâ]metro|parameter|line|linha/i.test(d)) return 'O carrinho mudou em outra aba. Atualizamos a lista; confira e tente de novo.';
    if (d) return d;
    return 'Não deu para atualizar o carrinho. Confira a conexão e tente de novo.';
  }

  /* ---------- rede ---------- */
  function post(url, data) {
    var ctl = window.AbortController ? new AbortController() : null, timer = ctl ? window.setTimeout(function () { ctl.abort(); }, 15000) : 0;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data), signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'erro'); e.data = j; e.status = r.status; throw e; } return j; }); })
      .then(function (j) { window.clearTimeout(timer); return j; }, function (e) { window.clearTimeout(timer); throw e; });
  }

  /* ---------- aplicar as seções devolvidas ---------- */
  var observer = null;
  function applySections(sections) {
    if (!sections) return false;
    var b = sections['cart-icon-bubble'], bubble = document.getElementById('cart-icon-bubble');
    if (b && bubble) { var d = parse(b), inner = q('.shopify-section', d); bubble.innerHTML = inner ? inner.innerHTML : d.body.innerHTML; }
    var dr = sections['cart-drawer'], h = host();
    if (!dr || !h) return false;
    var nd = q('#CartDrawer', parse(dr)); if (!nd) return false;
    var oldBody = body(), top = oldBody ? oldBody.scrollTop : 0;
    h.innerHTML = nd.innerHTML;
    if (observer) observer.takeRecords();      // a troca é nossa: não é preciso tratá-la de novo
    var nb = body(); if (nb) nb.scrollTop = top;
    return true;
  }
  function refresh() {
    return fetch('/?sections=' + SECTIONS)
      .then(function (r) { if (!r.ok) throw new Error('refresh'); return r.json(); })
      .then(function (s) { applySections(s); });
  }

  /* ---------- depois de cada troca de HTML ---------- */
  function syncState() {
    var p = q('[data-lzd]'), d = drawer();
    if (!p || !d) return;
    d.classList.toggle('is-empty', parseInt(p.getAttribute('data-count'), 10) === 0);
  }
  var lastCount = null;
  function afterSwap(focusSels, external) {
    syncState();
    var p = q('[data-lzd]'), n = p ? parseInt(p.getAttribute('data-count'), 10) : null;
    if (isOpen()) { initNudges(); }   // só com a gaveta aberta: ao abrir, o observador de classe pede o que falta
    if (external && lastCount !== null && n > lastCount) {   // compra por fora (ex.: "Complete a decoração"): avisa quem usa leitor de tela
      var first = q('.lzd-item__name'); live((first ? first.textContent.trim() : 'Peça') + ' adicionada ao carrinho. ' + n + (n === 1 ? ' item.' : ' itens.'));
    }
    if (n !== null) lastCount = n;
    if (isOpen() && !external) refocus(focusSels || ['[data-lzd-close]']);
    document.dispatchEvent(new CustomEvent('lzd:cart-updated', { detail: { external: !!external } }));
  }
  function refocus(sels) {
    for (var i = 0; i < sels.length; i++) {
      var el = q(sels[i]);
      if (el && !el.disabled) {
        if (typeof window.trapFocus === 'function' && host()) { try { window.trapFocus(host(), el); return; } catch (e) { /* cai no foco simples */ } }
        try { el.focus({ preventScroll: true }); } catch (e2) { el.focus(); }
        return;
      }
    }
  }

  function mutate(url, data, opts) {
    opts = opts || {};
    if (busy) return Promise.resolve(false);
    busy = true;
    if (!opts.keepUndo) clearUndo();
    data.sections = SECTIONS; data.sections_url = window.location.pathname;
    return post(url, data).then(function (res) {
      var ok = applySections(res.sections);
      return ok ? null : refresh();
    }).then(function () {
      busy = false;
      showError('');
      afterSwap(opts.focus);
      if (opts.say) { var t = q('[data-lzd-total]'); live(opts.say + (t ? ' Total ' + t.textContent + '.' : '')); }
      return true;
    }).catch(function (err) {
      busy = false;
      var msg = erroTexto(err);
      return refresh().then(function () { afterSwap(null); }, function () {}).then(function () { showError(msg); return false; });
    });
  }

  /* ---------- quantidade ---------- */
  function setQty(li, qty) {
    var key = li.getAttribute('data-key'), name = li.getAttribute('data-name') || '';
    var inc = qty > parseInt(li.getAttribute('data-qty'), 10), pos = items().indexOf(li) + 1;
    var base = '[data-lzd-list] > li:nth-child(' + pos + ') ';
    li.classList.add('is-busy');
    return mutate('/cart/change.js', { id: key, quantity: qty }, {
      focus: inc ? [base + '[data-lzd-inc]', base + '[data-lzd-dec]'] : [base + '[data-lzd-dec]', base + '[data-lzd-inc]'],
      say: name + ': ' + qty + (qty === 1 ? ' unidade.' : ' unidades.')
    }).then(function (ok) { if (document.body.contains(li)) li.classList.remove('is-busy'); return ok; });
  }

  /* ---------- remover e desfazer ---------- */
  function clearUndo() {
    window.clearTimeout(undoTimer); undo = null;
    var bar = q('[data-lzd-undo]'); if (bar) { bar.hidden = true; bar.textContent = ''; }
  }
  function showUndo(name) {
    var bar = q('[data-lzd-undo]'); if (!bar) return;
    bar.hidden = false;
    bar.innerHTML = '<span></span> <button type="button" data-lzd-undo-do>Desfazer</button>';
    bar.firstChild.textContent = name + ' foi removido.';
    window.clearTimeout(undoTimer);
    undoTimer = window.setTimeout(clearUndo, 6000);
  }
  function removeItem(li) {
    var key = li.getAttribute('data-key'), name = li.getAttribute('data-name') || 'O item';
    li.classList.add('is-busy');
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var it = null;
      c.items.forEach(function (i) { if (i.key === key) it = i; });
      var saved = it ? { id: it.variant_id, quantity: it.quantity, properties: it.properties || null, name: name } : null;
      return mutate('/cart/change.js', { id: key, quantity: 0 }, { focus: null, say: name + ' removido do carrinho.' }).then(function (ok) {
        if (ok === false) { if (document.body.contains(li)) li.classList.remove('is-busy'); return; }
        if (saved) { undo = saved; showUndo(saved.name); refocus(['[data-lzd-undo-do]']); }
      });
    }).catch(function () { clearUndo(); if (document.body.contains(li)) li.classList.remove('is-busy'); showError('Não deu para atualizar o carrinho. Confira a conexão e tente de novo.'); });
  }
  function doUndo() {
    if (!undo) return;
    var u = undo; undo = null; window.clearTimeout(undoTimer);
    var item = { id: u.id, quantity: u.quantity };
    if (u.properties && Object.keys(u.properties).length) item.properties = u.properties;
    return mutate('/cart/add.js', { items: [item] }, { focus: ['[data-lzd-item][data-variant-id="' + u.id + '"] .lzd-item__name', '[data-lzd-list]'], say: u.name + ' voltou para o carrinho.' });
  }

  /* ---------- atalho para completar a faixa de desconto ---------- */
  function parseTiers(html) {
    var out = [], re = /discount:\s*(\{[^}]*\}),[\s\S]{0,4000}?subtitle:\s*"([^"]*)",\s*maxQuantity:\s*(?:\d+|null),\s*minQuantity:\s*(\d+)/g, m;
    while ((m = re.exec(html))) {
      var d; try { d = JSON.parse(m[1]); } catch (e) { continue; }
      var min = parseInt(m[3], 10), sub = (m[2].match(/(\d{1,3}(?:\.\d{3})+(?:,\d+)?|\d+(?:,\d+)?)/) || [])[1], unit = null;
      if (sub) unit = Math.round(parseFloat(sub.replace(/\./g, '').replace(',', '.')) * 100);
      if (d && d.type === 'percentage' && d.value > 0 && min > 1) out.push({ min: min, pct: d.value, unit: unit });
    }
    out.sort(function (a, b) { return a.min - b.min; });
    return out;
  }
  function tiersFor(handle) {
    if (tiersMem[handle]) return Promise.resolve(tiersMem[handle]);
    var c = store('lzk_t_' + handle);
    if (c) { try { tiersMem[handle] = JSON.parse(c); return Promise.resolve(tiersMem[handle]); } catch (e) { /* refaz */ } }
    return fetch('/products/' + encodeURIComponent(handle)).then(function (r) {
      if (!r.ok) throw new Error('produto');
      return r.text();
    }).then(function (t) {
      var l = parseTiers(t); tiersMem[handle] = l; store('lzk_t_' + handle, JSON.stringify(l)); return l;
    }).catch(function () { return []; });
  }
  /* O subtítulo do Koala ("R$ 269,9 cada") vale para a variação padrão da página do produto; a faixa vale em % para qualquer
     variação. O preço sai da variação que está no carrinho (original × (1 − %)); o subtítulo só entra quando concorda com essa
     conta (±1%). Se não concorda, o texto diz "cerca de". */
  function paintNudge(li, tiers) {
    var btn = q('[data-lzd-nudge]', li); if (!btn) return;
    var txt = q('[data-lzd-nudge-txt]', btn);
    var qty = parseInt(li.getAttribute('data-qty'), 10), orig = parseInt(li.getAttribute('data-unit-orig'), 10);
    var inc = q('[data-lzd-inc]', li), max = inc ? parseInt(inc.getAttribute('data-max'), 10) || 10 : 10;
    var next = null;
    tiers.forEach(function (t) { if (!next && t.min > qty) next = t; });
    if (!next || next.min > max) { btn.hidden = true; return; }
    var calc = Math.round(orig * (1 - next.pct / 100)), exact = !!(next.unit && Math.abs(next.unit - calc) <= calc * 0.01);
    var unit = exact ? next.unit : calc;
    if (!(unit < orig)) { btn.hidden = true; return; }
    btn.setAttribute('data-min', String(next.min));
    if (txt) txt.textContent = 'Leve mais ' + (next.min - qty) + ' e pague ' + (exact ? '' : 'cerca de ') + brl(unit) + ' cada';
    btn.hidden = false;
  }
  function initNudges() {
    items().forEach(function (li) {
      var btn = q('[data-lzd-nudge]', li);
      if (btn && !btn.hidden) return; // veio do servidor (metacampos luzzart.qtd_faixa_*)
      tiersFor(li.getAttribute('data-handle')).then(function (t) { if (document.body.contains(li)) paintNudge(li, t); });
    });
  }

  /* ---------- eventos (delegados no documento; sobrevivem às trocas de HTML) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button, a') : null;
    if (!t || !t.closest('cart-drawer.lzd')) return;
    var li = t.closest('[data-lzd-item]');
    if (li && t.hasAttribute('data-lzd-inc')) { e.preventDefault(); setQty(li, parseInt(li.getAttribute('data-qty'), 10) + 1); return; }
    if (li && t.hasAttribute('data-lzd-dec')) { e.preventDefault(); setQty(li, Math.max(1, parseInt(li.getAttribute('data-qty'), 10) - 1)); return; }
    if (li && t.hasAttribute('data-lzd-nudge')) { e.preventDefault(); setQty(li, parseInt(t.getAttribute('data-min'), 10)); return; }
    if (li && t.hasAttribute('data-lzd-remove')) { e.preventDefault(); removeItem(li); return; }
    if (t.hasAttribute('data-lzd-undo-do')) { e.preventDefault(); doUndo(); return; }
  });

  /* ---------- abrir e fechar: foco no ✕, rolagem da página travada, foco devolvido pelo tema ---------- */
  function watchDrawer() {
    var d = drawer(); if (!d || d.__lzdWatch) return;
    d.__lzdWatch = true;
    var wasOpen = false;
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var open = d.classList.contains('active');
        if (open === wasOpen) return;
        wasOpen = open;
        if (open) {
          document.documentElement.classList.add('overflow-hidden');
          initNudges(); syncStale();
          window.setTimeout(function () {
            var c = q('[data-lzd-close]', d);
            if (!c || !d.classList.contains('active')) return;
            if (typeof window.trapFocus === 'function' && host()) { try { window.trapFocus(host(), c); return; } catch (e) { /* foco simples */ } }
            c.focus();
          }, 380);
        } else {
          document.documentElement.classList.remove('overflow-hidden');
          document.body.classList.remove('overflow-hidden');
          clearUndo();
        }
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
    // trocas feitas por outros arquivos do tema (compra pela PDP, cartões, "Complete a decoração"): refaz o que depende do HTML
    var h = host();
    if (h && window.MutationObserver) {
      observer = new MutationObserver(function () { afterSwap(null, true); });
      observer.observe(h, { childList: true });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { var d = drawer(); if (d && typeof d.close === 'function') d.close(); }
  });

  /* ajuste 6: carrinho mudou em outra aba (ou por app) enquanto a página estava parada: ao abrir, compara com /cart.js */
  function syncStale() {
    var p = q('[data-lzd]'); if (!p || busy) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var cur = q('[data-lzd]'); if (!cur || busy) return;
      if (c.item_count !== parseInt(cur.getAttribute('data-count'), 10) || String(c.total_price) !== cur.getAttribute('data-total')) {
        return refresh().then(function () { afterSwap(null); });
      }
    }).catch(function () { /* sem rede: segue com o que está na tela */ });
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden && isOpen()) syncStale(); });

  function init() {
    watchDrawer();
    syncState();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted && drawer()) refresh().then(function () { afterSwap(null); }).catch(function () {}); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
